import { Facade } from "@/modules/budget/monitoring/input-forms/types/roots/Facade";
import { FilterSettingsForm } from "@/modules/budget/monitoring/input-forms/types/roots/FilterSettingsForm";
import { App9FilterSettingsForm } from "@/modules/budget/monitoring/input-forms/components/application9/app9InputForm";

export class App9InputFormFacade implements Facade {
    getFilterSettings(): FilterSettingsForm {
        const form: App9FilterSettingsForm = {
            user_id: "",
            edit_access: false,
            delete_access: false,
            convert: 1000,
            application: null,
            report_form_view: 1,
            child_status: null,
            show_subventions: false
        }
        return form
    }

}